module.exports = __webpack_public_path__ + "img/Flag_of_Uganda.b6904678.svg";